import React from 'react';

/**
 * @typedef {Object} AuthCtx
 * @property {Record<string, any>} cubohUser
 * @property {Record<string, any>} user
 * @property {() => void} logout
 * @property {(email: string, password: string, uniqueKey?: string, setPasswordViaLogin?: boolean) => Promise<void>} login
 * @property {Record<string, { id: string, [key: string]: unknown }>} merchants
 * @property {Record<string, { id: string, [key: string]: unknown }>} companies
 * @property {boolean} isInternalUser
 * @property {boolean} isCompanyAdmin
 * @property {boolean} isUserCubohOnly
 * @property {boolean} isImpersonating
 * @property {boolean} isInitialLoad
 * @property {boolean} isLoading
 * @property {(isLoading: boolean) => void} setIsLoading
 * @property {Record<string, boolean>} flags
 * @property {(update: { company: Record<string, any> & { id: number } }) => void} updateCompanyDetails
 */

/** @type {AuthCtx} */
const defaultAuthCtxValue = {};
export const AuthContext = React.createContext(defaultAuthCtxValue);
